import {
  Component,
  OnInit,
  AfterViewInit,
  OnChanges,
  OnDestroy,
  ViewEncapsulation,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { Router } from "@angular/router";

import { Store, select } from "@ngrx/store";
import { Observable, Subscription } from "rxjs";
import { DashboardUtils } from "../../shared/dashboardUtils/vehicles/dashboardUtils";
import {
  getTransactionsList,
  getVehicleAverageComsuptionList,
} from "../../store/actions/dashboard/dashboard.actions";
import {
  AppState,
  dashboardAverageStateList,
  dashboardIsConsumedProductLoadingState,
  dashboardIsLoadingState,
  dashboardTransactionStateList,
} from "../../store/reducers";

import { TranslateService } from "@ngx-translate/core";
import { Title } from "@angular/platform-browser";
import {
  AdvancedFilter,
  FieldType,
  FilterEvent,
  FilterName,
} from "../../models/custom-table/custom-table.model";

import { DashboardThemeService } from "../../shared/services/dashboard-theme/dashboard-theme.service";
import { AppSessionService } from "../../shared/services/app-session/app-session.service";
import { BusinessType } from "src/app/models/enums/businessType.enum";

@Component({
  selector: "app-fleet-dashboard",
  templateUrl: "./fleet-dashboard.component.html",
  styleUrls: ["./fleet-dashboard.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class FleetDashboardComponent
  implements OnInit, OnDestroy, AfterViewInit, OnChanges
{
  @Input() businessTypes: BusinessType[];
  
  @Output() selectBusiness: EventEmitter<BusinessType> = new EventEmitter<BusinessType>();

  formatFunction: Function;
  averagesMetricFunction: Function;
  transactionFuncion: Function;
  transactionMetricFunction: Function;
  odometerFunction: Function;
  odometerMetricFunction: Function;
  totalFueledVolumeFunction: Function;
  totalFueledVolumeMetricFunction: Function;
  topFunction: Function;

  theme: any;
  items: any[];
  options: any = {
    propertyName: "calculatedAverage",
    propertyValue: "calculatedConsumption",
    filterRule: "L/100Km",
  };

  odometerOptions: any = {
    propertyName: "totalOdometer",
    propertyValue: undefined,
    filterRule: undefined,
    handleDuplicates: true,
  };

  fueledVoluemOptions: any = {
    propertyName: "totalVolume",
    propertyValue: undefined,
    filterRule: undefined,
    handleDuplicates: true,
  };

  transactionOptions: any = {
    propertyName: "records",
    propertyValue: undefined,
    filterRule: undefined,
  };

  averagesMeasurements: any[] = [];

  transactionMeasurements: any[] = [];

  topOptions: any[] = [
    { code: "Top3", description: "Top 3" },
    { code: "Top5", description: "Top 5" },
    { code: "Top7", description: "Top 7" },
    { code: "Top10", description: "Top 10" },
    { code: "all", description: "All" },
  ];
  public itemsList$: Observable<any[]>;
  public itemsList: any[];
  public itemsListSubs: Subscription;

  public transactionsList$: Observable<any[]>;
  public transactionsList: any[];
  public transactionsListSubs: Subscription;

  isLoading$: Observable<boolean>;
  isProductConsumedLoading$: Observable<boolean>;

  langSubscription: Subscription;

  firstLoad = true;
  dashboardDateMode: string = 'MONTH';

  constructor(
    private store: Store<AppState>,
    private translate: TranslateService,
    private titleService: Title
  ) {
    this.titleService.setTitle(this.translate.instant("DashBoard.Details"));
    this.averagesMeasurements = [
      {
        code: "percentageDeviation",
        description: this.translate.instant("DashBoard.percentageDeviation"),
        field: "calculatedAverage",
        property: "percentageDeviation",
      },
      {
        code: "deviation",
        description: this.translate.instant("DashBoard.Deviation"),
        field: "calculatedAverage",
        property: "deviation",
      },
      {
        code: "targetConsumption",
        description: this.translate.instant("DashBoard.targetConsumption"),
        field: "currentAverage",
        property: "targetConsumption",
      },
      {
        code: "currentConsumption",
        description: this.translate.instant("DashBoard.currentConsumption"),
        field: "currentAverage",
        property: "currentConsumption",
      },
      {
        code: "calculatedConsumption",
        description: this.translate.instant("DashBoard.calculatedConsumption"),
        field: "calculatedAverage",
        property: "calculatedConsumption",
      },
      {
        code: "totalOdometer",
        description: this.translate.instant("DashBoard.totalOdometer"),
        field: "totalOdometer",
        property: undefined,
        handleDuplicates: true,
      },
      {
        code: "totalWorkingHours",
        description: this.translate.instant("DashBoard.totalWorkingHours"),
        field: "totalWorkingHours",
        property: undefined,
        handleDuplicates: true,
      },
      {
        code: "totalVolume",
        description: this.translate.instant("DashBoard.totalVolume"),
        field: "totalVolume",
        property: undefined,
        handleDuplicates: true,
      },
    ];
    this.transactionMeasurements = [
      {
        code: "amount",
        description: this.translate.instant("DashBoard.amount"),
        field: "amount",
        property: undefined,
      },
      {
        code: "averageAmount",
        description: this.translate.instant("DashBoard.averageAmount"),
        field: "averageAmount",
        property: undefined,
      },
      {
        code: "averageVolume",
        description: this.translate.instant("DashBoard.averageVolume"),
        field: "averageVolume",
        property: undefined,
      },
      {
        code: "maxAmount",
        description: this.translate.instant("DashBoard.maxAmount"),
        field: "maxAmount",
        property: undefined,
      },
      {
        code: "maxVolume",
        description: this.translate.instant("DashBoard.maxVolume"),
        field: "maxVolume",
        property: undefined,
      },
      {
        code: "minAmount",
        description: this.translate.instant("DashBoard.minAmount"),
        field: "minAmount",
        property: undefined,
      },
      {
        code: "minVolume",
        description: this.translate.instant("DashBoard.minVolume"),
        field: "minVolume",
        property: undefined,
      },
      {
        code: "records",
        description: this.translate.instant("DashBoard.records"),
        field: "records",
        property: undefined,
      },
      {
        code: "volume",
        description: this.translate.instant("DashBoard.volume"),
        field: "volume",
        property: undefined,
      },
    ];

    this.isLoading$ = this.store.pipe(select(dashboardIsLoadingState));
    this.isProductConsumedLoading$ = this.store.pipe(
      select(dashboardIsConsumedProductLoadingState)
    );
    this.itemsList$ = this.store.pipe(select(dashboardAverageStateList));
    this.transactionsList$ = this.store.pipe(
      select(dashboardTransactionStateList)
    );
  }

  ngOnInit() {
    this.dashboardDateMode = localStorage.getItem("dashboardDateMode") || "MONTH";

    this.getMetricAveragesTranslations();
    this.getMetricProductTranslations();

    this.formatFunction = DashboardUtils.getAverageConsumption;
    this.transactionFuncion = DashboardUtils.getTransactions;
    this.transactionMetricFunction = DashboardUtils.productGroupPieChartMetrics;
    this.averagesMetricFunction = DashboardUtils.averagesPieChartMetrics;
    this.topFunction = DashboardUtils.getTopResult;
    this.odometerFunction = DashboardUtils.getOdometer;
    this.odometerMetricFunction = DashboardUtils.averagesPieChartMetrics;
    this.totalFueledVolumeFunction = DashboardUtils.getFueledVolume;
    this.totalFueledVolumeMetricFunction =
      DashboardUtils.averagesPieChartMetrics;
    this.loadLangChanges();
  }

  ngOnChanges() {
    this.getMetricAveragesTranslations();
    this.getMetricProductTranslations();
  }

  loadLangChanges() {
    this.langSubscription = this.translate.onLangChange.subscribe(() => {
      this.titleService.setTitle(this.translate.instant("DashBoard.Details"));
    });
  }

  public ngAfterViewInit(): void {
    this.getMetricAveragesTranslations();
    this.getMetricProductTranslations();
  }

  getMetricAveragesTranslations() {
    this.translate.onLangChange.subscribe((translate) => {
      this.averagesMeasurements = [
        {
          code: "percentageDeviation",
          description: this.translate.instant("DashBoard.percentageDeviation"),
          field: "calculatedAverage",
          property: "percentageDeviation",
        },
        {
          code: "deviation",
          description: this.translate.instant("DashBoard.Deviation"),
          field: "calculatedAverage",
          property: "deviation",
        },
        {
          code: "targetConsumption",
          description: this.translate.instant("DashBoard.targetConsumption"),
          field: "currentAverage",
          property: "targetConsumption",
        },
        {
          code: "currentConsumption",
          description: this.translate.instant("DashBoard.currentConsumption"),
          field: "currentAverage",
          property: "currentConsumption",
        },
        {
          code: "calculatedConsumption",
          description: this.translate.instant(
            "DashBoard.calculatedConsumption"
          ),
          field: "calculatedAverage",
          property: "calculatedConsumption",
        },
        {
          code: "totalOdometer",
          description: this.translate.instant("DashBoard.totalOdometer"),
          field: "totalOdometer",
          property: undefined,
          handleDuplicates: true,
        },
        {
          code: "totalWorkingHours",
          description: this.translate.instant("DashBoard.totalWorkingHours"),
          field: "totalWorkingHours",
          property: undefined,
          handleDuplicates: true,
        },
        {
          code: "totalVolume",
          description: this.translate.instant("DashBoard.totalVolume"),
          field: "totalVolume",
          property: undefined,
          handleDuplicates: true,
        },
      ];
    });
  }

  getMetricProductTranslations() {
    this.translate.onLangChange.subscribe((translate) => {
      return (this.transactionMeasurements = [
        {
          code: "amount",
          description: this.translate.instant("DashBoard.amount"),
          field: "amount",
          property: undefined,
        },
        {
          code: "averageAmount",
          description: this.translate.instant("DashBoard.averageAmount"),
          field: "averageAmount",
          property: undefined,
        },
        {
          code: "averageVolume",
          description: this.translate.instant("DashBoard.averageVolume"),
          field: "averageVolume",
          property: undefined,
        },
        {
          code: "maxAmount",
          description: this.translate.instant("DashBoard.maxAmount"),
          field: "maxAmount",
          property: undefined,
        },
        {
          code: "maxVolume",
          description: this.translate.instant("DashBoard.maxVolume"),
          field: "maxVolume",
          property: undefined,
        },
        {
          code: "minAmount",
          description: this.translate.instant("DashBoard.minAmount"),
          field: "minAmount",
          property: undefined,
        },
        {
          code: "minVolume",
          description: this.translate.instant("DashBoard.minVolume"),
          field: "minVolume",
          property: undefined,
        },
        {
          code: "records",
          description: this.translate.instant("DashBoard.records"),
          field: "records",
          property: undefined,
        },
        {
          code: "volume",
          description: this.translate.instant("DashBoard.volume"),
          field: "volume",
          property: undefined,
        },
      ]);
    });
  }

  setSelectedDateMode(mode: string) {
    this.dashboardDateMode = mode;
    localStorage.setItem("dashboardDateMode", mode);
  }

  getDates(dates) {
    const startDate = this.firstLoad && localStorage.getItem("dashboardStartDate") ? localStorage.getItem("dashboardStartDate") : dates.startDate;
    const endDate = this.firstLoad && localStorage.getItem("dashboardEndDate") ? localStorage.getItem("dashboardEndDate") : dates.endDate;

    if (!this.firstLoad) {
      localStorage.setItem("dashboardStartDate", dates.startDate);
      localStorage.setItem("dashboardEndDate", dates.endDate);
    }

    let dateRange: FilterEvent = {
      advancedFilter: [],
    };

    let startDateFilter: AdvancedFilter = {
      column: "posDate",
      fieldType: FieldType.DATE_TIME,
      id: null,
      operator: FilterName.GREATER_THAN_EQUAL,
      value: startDate,
    };
    let endDateFilter: AdvancedFilter = {
      column: "posDate",
      fieldType: FieldType.DATE_TIME,
      id: null,
      operator: FilterName.LESS_THAN_EQUAL,
      value: endDate,
    };

    dateRange.advancedFilter.push(startDateFilter);
    dateRange.advancedFilter.push(endDateFilter);

    this.store.dispatch(
      getVehicleAverageComsuptionList({
        options: {
          paging: {
            skip: 0,
            top: 999,
          },
          filteringArgs: undefined,
          sortingArgs: undefined,
          advancedFilteringArgs: dateRange,
        },
      })
    );
    this.store.dispatch(
      getTransactionsList({
        options: {
          paging: {
            skip: 0,
            top: 999,
          },
          filteringArgs: undefined,
          sortingArgs: undefined,
          advancedFilteringArgs: dateRange,
        },
      })
    );

    this.firstLoad = false;
  }

  setSelectedBusinessType(businessType: BusinessType) {
    this.selectBusiness.emit(businessType);
  }

  ngOnDestroy(): void {
    if (this.itemsListSubs) {
      this.itemsListSubs.unsubscribe();
    }
    if (this.transactionsListSubs) {
      this.transactionsListSubs.unsubscribe();
    }
    if (this.langSubscription) {
      this.langSubscription.unsubscribe();
    }
  }
}
